import { api } from './api';
import type {
  AuthMethod,
  AuthMethodsListResponse,
  AuthMethodsUpdateResponse,
  AuthMethodToggleResponse,
} from '../types/authMethods';

export const authMethodsApi = {
  /**
   * Get all auth methods for a project with their enabled/configured status
   */
  list: async (projectId: string): Promise<AuthMethodsListResponse> => {
    return api.get<AuthMethodsListResponse>(`/api/projects/${projectId}/auth-methods`);
  },

  /**
   * Update enabled auth methods for a project
   */
  update: async (
    projectId: string,
    authMethods: AuthMethod[]
  ): Promise<AuthMethodsUpdateResponse> => {
    return api.put<AuthMethodsUpdateResponse>(`/api/projects/${projectId}/auth-methods`, {
      auth_methods: authMethods,
    });
  },

  /**
   * Enable a specific auth method
   */
  enable: async (
    projectId: string,
    method: AuthMethod
  ): Promise<AuthMethodToggleResponse> => {
    return api.post<AuthMethodToggleResponse>(
      `/api/projects/${projectId}/auth-methods/${method}/enable`
    );
  },

  /**
   * Disable a specific auth method
   */
  disable: async (
    projectId: string,
    method: AuthMethod
  ): Promise<AuthMethodToggleResponse> => {
    return api.post<AuthMethodToggleResponse>(
      `/api/projects/${projectId}/auth-methods/${method}/disable`
    );
  },
};
